export enum CardViewEnumT {
  'details' = 0,
  'share' = 1,
  'shareBack' = 2,
}

export type SetCardViewFnT = (viewName: CardViewEnumT) => void;
